import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { navigateTo } from '../store/slices/siteSlice'; // Adjust the import path as necessary
var useChaseListNavigate = function () {
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var chaseListNavigate = useCallback(function (path) {
        dispatch(navigateTo(path));
        navigate(path);
    }, [dispatch, navigate]);
    return chaseListNavigate;
};
export default useChaseListNavigate;
